import type { RootState } from '../index'

export const selectApiKeys = (state: RootState) => state.apiKeys.keys
export const selectApiKeysLoading = (state: RootState) => state.apiKeys.loading
export const selectApiKeysError = (state: RootState) => state.apiKeys.error
export const selectNewApiKey = (state: RootState) => state.apiKeys.newKey
